import { render, staticRenderFns } from "./DialogAdminPasswordReset.vue?vue&type=template&id=782c31dc&scoped=true"
import script from "./DialogAdminPasswordReset.vue?vue&type=script&lang=js"
export * from "./DialogAdminPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./DialogAdminPasswordReset.vue?vue&type=style&index=0&id=782c31dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782c31dc",
  null
  
)

export default component.exports